<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							General Ledger Close/ReOpen
						</h4>
						<p class="card-category">
							Close GL posting up to a date, or reopen from a selected date.
						</p>
					</div>
					<div class="card-body">
						<div class="status-grid">
							<div class="status-card">
								<div class="status-label">Closed Through</div>
								<div class="status-value">{{ closedThroughDisplay }}</div>
							</div>
							<div class="status-card">
								<div class="status-label">Open From</div>
								<div class="status-value">{{ openFromDisplay }}</div>
							</div>
						</div>

						<div class="form-row mt-4">
							<div class="col-md-4">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Posting Date</mat-label>
									<input matInput type="date" [(ngModel)]="selectedDate" />
								</mat-form-field>
							</div>
							<div class="col-md-8 d-flex align-items-center action-buttons">
								<button mat-raised-button color="warn" class="mr-2" (click)="closeByDate()" [disabled]="isSaving || !selectedDate">
									Close GL
								</button>
								<button mat-raised-button color="primary" (click)="reopenByDate()" [disabled]="isSaving || !selectedDate">
									ReOpen GL
								</button>
							</div>
						</div>

						<div class="text-muted small mt-2" *ngIf="isLoadingStatus">
							Loading current status...
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
